import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SkillAssessmentCard = ({ assessment, onStart }) => {
  const getScoreColor = (score) => {
    if (score >= 80) return 'text-green-600 bg-green-100 dark:bg-green-900/30';
    if (score >= 60) return 'text-blue-600 bg-blue-100 dark:bg-blue-900/30';
    if (score >= 40) return 'text-yellow-600 bg-yellow-100 dark:bg-yellow-900/30';
    return 'text-red-600 bg-red-100 dark:bg-red-900/30';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">{assessment?.title}</h3>
          <p className="text-sm text-muted-foreground mb-3">{assessment?.description}</p>
        </div>
        <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name={assessment?.icon} size={24} className="text-primary" />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="text-center">
          <div className="text-xs text-muted-foreground mb-1">Questions</div>
          <div className="text-lg font-semibold text-foreground">{assessment?.questions}</div>
        </div>
        <div className="text-center">
          <div className="text-xs text-muted-foreground mb-1">Duration</div>
          <div className="text-lg font-semibold text-foreground">{assessment?.duration}</div>
        </div>
        <div className="text-center">
          <div className="text-xs text-muted-foreground mb-1">Difficulty</div>
          <div className="text-lg font-semibold text-foreground">{assessment?.difficulty}</div>
        </div>
      </div>
      {assessment?.lastScore !== null ? (
        <div className="mb-4">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Last Score</span>
            <span className={`text-sm font-semibold px-3 py-1 rounded-full ${getScoreColor(assessment?.lastScore)}`}>
              {assessment?.lastScore}%
            </span>
          </div>
          <div className="text-xs text-muted-foreground">
            Taken on {assessment?.lastAttempt}
          </div>
        </div>
      ) : (
        <div className="mb-4 text-sm text-muted-foreground">
          Not attempted yet
        </div>
      )}
      <Button
        variant={assessment?.lastScore !== null ? 'outline' : 'default'}
        fullWidth
        onClick={() => onStart(assessment)}
        iconName={assessment?.lastScore !== null ? 'RefreshCw' : 'Play'}
        iconPosition="left"
      >
        {assessment?.lastScore !== null ? 'Retake Assessment' : 'Start Assessment'}
      </Button>
    </div>
  );
};

export default SkillAssessmentCard;